<template>
  <div v-if="isShowQR" id="punch-card-campaign-qr-wrapper">
    <div id="punch-card-campaign-qr-container" :class="{ 'shown': isSlide }">
      <img src="@/assets/images/close-dark-gray.svg" alt="close-qr" class="cursor-pointer" @click="slideRight">
      <b-container fluid class="campaign-qr-container h-100">
        <div class="position-sticky bg-white qr-punch-card-sidebar-header">
          <div class="d-flex flex-column align-items-start justify-content-between">
            <div class="flex-grow-1">
              <h3 class="mb-0">Download QR Code</h3>
              <h4>{{ campaignDetails.name }}</h4>
            </div>
            <div class="punch-card-qr-tabs d-flex w-100 align-items-start justify-content-between">
              <b-button v-for="(qr, index) in qrTabs" :key="`button-qr-qr-${qr.template.toLowerCase()}-${index}`"
                :id="`button-qr-qr-${qr.template.toLowerCase()}-${index}`" @click="currentTab = qr.template"
                :class="['shadow-none text-uppercase flex-grow-1', { active: currentTab === qr.template }]">{{
                  qr.label
                }}</b-button>
            </div>
          </div>
        </div>
        <div class="qr-wrapper py-4 d-flex flex-column align-items-center justify-content-center">
          <div id="print-qr-wrapper"
            :class="['qr-code-wrapper d-flex flex-column align-items-center justify-content-center', `-${currentTab}`]">
            <h3 :class="['w-100 text-truncate px-5 text-center', { 'text-white': currentTab === 'earn' }]">{{
              campaignDetails.name }}</h3>
            <h4 :class="['mb-0 text-uppercase', { 'text-white': currentTab === 'earn' }]">{{ qrCodeDisplayText }}</h4>
            <div class="qr-code bg-white d-flex flex-column align-items-center justify-content-center">
              <div class="logo-container">
                <img :src="campaignDetails.image ? campaignDetails.image : '@/assets/images/rush-logo.png'"
                  alt="RUSH Logo" class="img-fluid">
              </div>
              <qrcode-vue :value="`http://${qrDomain}/${campaignDetails.uuid}/register`" :size='200'></qrcode-vue>
            </div>
            <p class="qr-domain text-white mb-0">
              <i class="bi bi-globe2 mr-2 mt-1" aria-hidden="true"></i>
              {{ qrDomain }}
            </p>
          </div>
          <div class="print-preview text-center py-3 w-100">Print Preview</div>
          <div class="qr-punch-card-sidebar-footer text-center">
            <b-button variant="primary" class="btn-pill" id="button-punch-card-campaign-download">Download</b-button>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import QrcodeVue from "qrcode.vue";
;
export default {
  props: {
    isShowQR: {
      type: Boolean,
      default: false
    }
  },
  components: { QrcodeVue },
  computed: {
    ...mapGetters("punchCard", ["campaignDetails"]),
    qrCodeDisplayText: {
      get() {
        return this.qrTabs.find(({ template }) => template === this.currentTab).label;
      },
      set(text) {
        return text;
      }
    }
  },
  data() {
    return {
      isSlide: false,
      currentTab: "earn",
      qrTabs: [
        { template: "earn", label: "Scan to Earn Stamps" },
        { template: "join", label: "Join A Campaign" }
      ],
      qrDomain: "estore.rush.ph"
    }
  },
  methods: {
    slideRight() {
      this.isSlide = false;
      this.currentTab = "earn";

      setTimeout(() => {
        this.$emit("hideCampaignQR");
        this.$store.commit("punchCard/INIT_CAMPAIGN_DATA");
      }, 300);
    }
  },
  watch: {
    isShowQR(value) {
      if (value) {
        setTimeout(() => this.isSlide = value, 100);
        document.body.style.overflowY = "hidden";
      } else {
        document.body.style.overflowY = null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#punch-card-campaign-qr-wrapper {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  background: rgba(0, 0, 0, 0.30);
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

#punch-card-campaign-qr-container {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  background-color: #fff;
  width: 55vw;
  height: 100vh;
  position: fixed;
  left: 100vw;
  transition: all 0.3s ease-in;
  padding: 24px 26px;

  &.shown {
    left: 45vw;
  }

  .campaign-qr-container {
    margin-top: 40px;
    padding-left: 82px;
    padding-right: 60px;
    max-height: 87vh;
    overflow-y: auto;

    .position-sticky {
      position: sticky;
      top: 0;
      z-index: 9;
    }

    h3 {
      font-family: MainFontBold, sans-serif;
      font-size: 24px;
      color: #49545C;
      margin-bottom: 26px;
    }

    h4 {
      font-family: MainFontRegular, sans-serif;
      font-size: 20px;
      color: #49545C;
    }

    .punch-card-qr-tabs {
      margin-top: 38px;
      border-bottom: solid 2px #C2C8CC;

      button {
        height: 42px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        background-color: transparent;
        border: 0;
        color: rgba(73, 84, 92, 0.5);
        font-family: MainFontBold, sans-serif;

        &.active {
          background-color: #F9F9F9;
          color: #2F3941;
        }
      }
    }

    .qr-wrapper {
      width: 100%;

      .qr-code-wrapper {
        width: 455px;
        height: 529px;
        background-image: url('~@/assets/images/punch-card-qr-container-bg.png');
        border-radius: 10px;

        &.-earn {
          background-blend-mode: multiply;
          background: #FF6B00 url('~@/assets/images/punch-card-qr-container-bg.png') no-repeat;

          .qr-code {
            margin-bottom: 20px;
          }
        }

        &.-join {
          h3 {
            margin-top: 22px;
          }

          .qr-domain {
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            background: #FF6B00;
            color: #fff;
            height: 63px;
          }
        }

        h3 {
          margin-bottom: 20px !important;
          font-size: 32px;
        }

        h4 {
          font-family: MainFontRegular, sans-serif;
          font-size: 22px;
        }

        .qr-code {
          width: 394px;
          height: 319px;
          border-radius: 10px;
          margin-top: 33px;

          .logo-container {
            width: 100px;
            height: 50px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 15px;

            &>img {
              object-fit: cover;
            }
          }
        }

        .qr-domain {
          font-family: MainFontBold, sans-serif;
          font-size: 18px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      .print-preview {
        font-size: 16px;
        color: #87929D;
        border-bottom: solid 2px #C2C8CC;
      }
    }
  }

  .qr-punch-card-sidebar-footer {
    padding-top: 25px;

    button {
      width: 200px;
      height: 44px;
    }
  }
}
</style>
